import {Injectable, Pipe, PipeTransform} from "@angular/core";

@Pipe({name:'phone'})
    @Injectable({
        providedIn: 'root' // or provide it in a specific module
    })
export class FormatPhonePipe implements PipeTransform {
    //transforms any phone number value from server to (xxx) xxx-xxxx and  clickable
    transform(value: string | number, clickable: boolean = false): string {
        if (value) {
            let s2 = ("" + value).replace(/\D/g, '');
            let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
            const formattedNumber = (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];

            if (clickable && formattedNumber) {
                return `<a href="tel:${s2}" class="text-blue-700 no-underline">${formattedNumber}</a>`;
            }

            return formattedNumber || '';
        } else {
            return '';
        }
    }
}
